module.exports = __webpack_public_path__ + "media/images/email-71bcb796285e0b760bcacc1879293603.svg";